import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e6a29e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "bottom-sheet-header" }
const _hoisted_3 = { class: "ml-auto" }
const _hoisted_4 = { class: "d-flex align-items-center all-day-wrapper" }
const _hoisted_5 = { class: "toggle-button-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "終日", -1))
const _hoisted_7 = { class: "d-flex align-items-center mb-4" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "d-flex flex-column align-items-center" }
const _hoisted_11 = { class: "my-4" }
const _hoisted_12 = ["disabled", "onClick"]

import AppButton from "@/components/atoms/button/AppButton.vue";
import ToggleButton from "@/components/atoms/button/ToggleButton.vue";
import AppFormSelect from "@/components/atoms/input/AppFormSelect.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import CustomValidationObserver from "@/plugins/CustomValidationObserver.vue";
import { ValidationProvider } from "@/plugins/veeValidate/veeValidate";
import { DesiredWorkSchedule } from "@/types/desired_work_schedule/DesiredWorkSchedule";
import {
  addDays,
  combineDateAndTime,
  formatFromISOString,
  formatFromUnixTimestamp,
  getDate,
  getHour,
  now,
  parseISO
} from "@/utils/date";
import { computed, nextTick, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleFormBottomSheet',
  props: {
    visible: { type: Boolean },
    selectedDate: {},
    selectedSchedules: {}
  },
  emits: ["update:visible", "save", "delete"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





const isAllDay = ref<boolean>(false);
const startAt = ref<string | null>(null);
const finishAt = ref<string | null>(null);

const formValues = computed(() => ({
  date: props.selectedDate,
  isAllDay: isAllDay.value,
  startAt: startAt.value,
  finishAt: finishAt.value
}));

const existsSchedule = computed(() => {
  return props.selectedSchedules.some(
    schedule => schedule.date === props.selectedDate
  );
});

const getPadHHmm = (hour: number) => {
  return `${hour.toString().padStart(2, "0")}:00`;
};

const formatTime = (date: number, time: number) => {
  const formattedTime = formatFromUnixTimestamp(
    combineDateAndTime(date, getPadHHmm(time)),
    "yyyy-MM-dd'T'HH:mm:ss+09:00"
  );
  return formattedTime;
};

const startAtOptions = computed(() => {
  const targetDate = props.selectedDate ? parseISO(props.selectedDate) : now();
  return [
    ...Array.from({ length: 24 }, (_, hour) => {
      return {
        text: getPadHHmm(hour),
        value: formatTime(targetDate, hour)
      };
    })
  ];
});

const finishAtOptions = computed(() => {
  const fromHour = formValues.value.startAt
    ? getHour(parseISO(formValues.value.startAt!))
    : null;
  const targetDate = props.selectedDate ? parseISO(props.selectedDate) : now();
  return [
    ...Array.from({ length: 36 })
      .map((_, index) => {
        return index + 1;
      })
      .filter(hour => {
        if (!fromHour) {
          return true;
        }
        return hour > fromHour;
      })
      .map(hour => {
        const upwardHour = hour < 24 ? hour : hour - 24;
        return {
          text:
            hour < 24 ? getPadHHmm(upwardHour) : `翌${getPadHHmm(upwardHour)}`,
          value:
            hour < 24
              ? formatTime(targetDate, upwardHour)
              : formatTime(addDays(targetDate, 1), upwardHour)
        };
      })
  ];
});

/**
 * 選択された日付に基づいてフォームのデフォルト値を設定する
 */
const setDefaultFormValues = () => {
  const targetSchedule = props.selectedSchedules.find(
    schedule => schedule.date === props.selectedDate
  );
  if (targetSchedule) {
    // 選択した日に既存の働きたい日がある場合は、その日の値をフォームのデフォルト値とする
    isAllDay.value = targetSchedule.isAllDay;
    startAt.value = targetSchedule.startAt || null;
    // モーダルの表示が更新されるまで待ってからfinishAtを更新する
    nextTick(() => {
      finishAt.value = targetSchedule.finishAt || null;
    });
  } else {
    // 選択した日に既存の働きたい日がない場合は、1つ前に選択した時のフォームの値をフォームのデフォルト値とする
    if (props.selectedDate && startAt.value && finishAt.value) {
      const parsedSelectedDate = parseISO(props.selectedDate);
      const parsedSelectedDateTomorrow = addDays(parsedSelectedDate, 1);
      const parsedStartAt = parseISO(startAt.value);
      const parsedFinishAt = parseISO(finishAt.value);
      // 選択した日付の選択肢とマッチするように、日付部分を更新する
      startAt.value = formatTime(parsedSelectedDate, getHour(parsedStartAt));
      // モーダルの表示が更新されるまで待ってからfinishAtを更新する
      nextTick(() => {
        finishAt.value = formatTime(
          // 終了日が日付を跨いでいた場合は、翌日の値をデフォルト値とする
          getDate(parsedStartAt) === getDate(parsedFinishAt)
            ? parsedSelectedDate
            : parsedSelectedDateTomorrow,
          getHour(parsedFinishAt)
        );
      });
    }
  }
};

watch(
  () => props.selectedDate,
  () => {
    setDefaultFormValues();
  }
);

watch(
  () => formValues.value.startAt,
  () => {
    finishAt.value = null;
  }
);

const closeBottomSheet = () => {
  emit("update:visible", false);
};

const toggleAllDay = () => {
  isAllDay.value = !isAllDay.value;
  startAt.value = null;
  finishAt.value = null;
};

const formatDate = (date: string | null) => {
  if (!date) return "";
  return formatFromISOString(date, "Y年M月d日 iiiii曜日");
};

const onClickSave = () => {
  if (!formValues.value.date) {
    return;
  }

  emit("save", {
    date: formValues.value.date,
    isAllDay: formValues.value.isAllDay,
    startAt: formValues.value.startAt,
    finishAt: formValues.value.finishAt
  });
};

const onClickDelete = () => {
  if (!formValues.value.date) {
    return;
  }

  emit("delete", formValues.value.date);
};

__expose({
  isAllDay,
  startAt,
  finishAt,
  setDefaultFormValues,
  toggleAllDay,
  formatDate,
  onClickSave,
  onClickDelete,
  closeBottomSheet
});

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: _ctx.visible,
    "hide-footer": "",
    "hide-header": "",
    "modal-class": "schedule-form-bottom-sheet",
    onHide: closeBottomSheet,
    onClose: closeBottomSheet
  }, {
    default: _withCtx(() => [
      _createVNode(CustomValidationObserver, { "initial-values": formValues.value }, {
        default: _withCtx(({ handleSubmit }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(formatDate(_ctx.selectedDate)), 1),
            _createTextVNode(),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(FeatherIcon, {
                icon: "x",
                size: "24",
                onClick: closeBottomSheet
              })
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(ToggleButton, {
                  checked: isAllDay.value,
                  onClick: toggleAllDay
                }, null, 8, ["checked"])
              ]),
              _createTextVNode(),
              _hoisted_6
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(ValidationProvider), {
                name: "開始時刻",
                rules: {
              required: !formValues.value.isAllDay
            },
                vid: "startAt"
              }, {
                default: _withCtx((validationState) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["mr-2", { 'disabled-time-option': formValues.value.isAllDay }])
                    }, "開始", 2),
                    _createTextVNode(),
                    _createVNode(AppFormSelect, {
                      value: startAt.value,
                      modelValue: startAt.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startAt).value = $event)),
                      firstOption: "選択して下さい",
                      formOptions: startAtOptions.value,
                      disabled: formValues.value.isAllDay,
                      class: "time-option",
                      "validation-state": validationState
                    }, null, 8, ["value", "modelValue", "formOptions", "disabled", "validation-state"])
                  ])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createTextVNode(),
              _createVNode(_unref(ValidationProvider), {
                name: "終了時刻",
                rules: {
              required: !formValues.value.isAllDay
            },
                vid: "finishAt"
              }, {
                default: _withCtx((validationState) => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["m-2", { 'disabled-time-option': formValues.value.isAllDay }])
                    }, "終了", 2),
                    _createTextVNode(),
                    _createVNode(AppFormSelect, {
                      value: finishAt.value,
                      modelValue: finishAt.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((finishAt).value = $event)),
                      firstOption: "選択して下さい",
                      formOptions: finishAtOptions.value,
                      disabled: formValues.value.isAllDay,
                      class: "time-option",
                      "validation-state": validationState
                    }, null, 8, ["value", "modelValue", "formOptions", "disabled", "validation-state"])
                  ])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(AppButton, {
                onClick: ($event: any) => (handleSubmit(onClickSave)),
                class: "save-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            登録する\n          ")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick"]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "delete-button",
                  disabled: !existsSchedule.value,
                  onClick: ($event: any) => (handleSubmit(onClickDelete))
                }, "\n              削除する\n            ", 8, _hoisted_12)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["initial-values"])
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})